import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantGeneralInfo = (token, id) => {
    return fetch(`${apiUrl}tenant_general_info/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantGeneralInfo
